import React, { ReactNode } from 'react'
import './FilterField.scss'

export type FilterFieldSize = 'normal' | 'wide' | 'full'

export interface FilterFieldProps {
  children: ReactNode
  /** Размер поля: normal (1 колонка), wide (2 колонки), full (вся ширина) */
  size?: FilterFieldSize
  /** Лейбл поля (опционально) */
  label?: string
  /** Кастомный className */
  className?: string
  /** Отображать поля в строку */
  inline?: boolean
}

export default function FilterField ({
  children,
  size = 'normal',
  label,
  className = '',
  inline = false
}: FilterFieldProps) {
  const sizeClass = size === 'wide' 
    ? 'FilterField--wide' 
    : size === 'full' 
      ? 'FilterField--full' 
      : ''
  
  const inlineClass = inline ? 'FilterField--inline' : ''

  return (
    <div className={`FilterField ${sizeClass} ${inlineClass} ${className}`}>
      {label && <label className="FilterField__Label">{label}</label>}
      {children}
    </div>
  )
}
